'use client';
import { ErrorPage } from '@/components/pages/ErrorPage/ErrorPage';

export default ErrorPage;